/**
 * An array of strings representing all currencies
 *
 * @enum {string}
 * @readonly
 */
export const Currency = Object.freeze({
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  CAD: 'CAD',
  AUD: 'AUD',
  JPY: 'JPY',
  CNY: 'CNY',
  HKD: 'HKD',
  CHF: 'CHF',
  INR: 'INR',
  BRL: 'BRL',
  QAR: 'QAR',
});

export const CurrencyDescriptions = Object.freeze({
  [Currency.USD]: {
    name: 'United States dollar',
    symbol: '$',
  },
  [Currency.EUR]: {
    name: 'Euro',
    symbol: '€',
  },
  [Currency.GBP]: {
    name: 'British pound sterling',
    symbol: '£',
  },
  [Currency.CAD]: {
    name: 'Canadian dollar',
    symbol: 'Can$',
  },
  [Currency.CHF]: {
    name: 'Swiss franc',
    symbol: 'CHF',
  },
  [Currency.AUD]: {
    name: 'Australian dollar',
    symbol: 'A$',
  },
  [Currency.JPY]: {
    name: 'Japanese yen',
    symbol: '¥',
  },
  [Currency.CNY]: {
    name: 'Chinese yuan',
    symbol: '¥',
  },
  [Currency.HKD]: {
    name: 'Hong kong dollar',
    symbol: 'HK$',
  },
  [Currency.INR]: {
    name: 'Indian rupee',
    symbol: '₹',
  },
  [Currency.BRL]: {
    name: 'Brazilian real',
    symbol: 'R$',
  },
  [Currency.QAR]: {
    name: 'Qatari riyal',
    symbol: 'QR',
  },
});

export function getCurrencyLabel(code) {
  return `${code} - ${CurrencyDescriptions[code]?.name}`;
}

/**
 * An object mapping currency codes to country codes
 *
 * @enum {string}
 * @readonly
 */
export const CurrencyCountryCodes = Object.freeze({
  AED: 'AE',
  AOA: 'AO',
  ARS: 'AR',
  AUD: 'AU',
  BDT: 'BD',
  BGN: 'BG',
  BHD: 'BH',
  BOB: 'BO',
  BRL: 'BR',
  BWP: 'BW',
  CAD: 'CA',
  CHF: 'CH',
  CLP: 'CL',
  CNY: 'CN',
  COP: 'CO',
  CZK: 'CZ',
  DKK: 'DK',
  EGP: 'EG',
  EUR: 'EU',
  GBP: 'GB',
  GMD: 'GM',
  HKD: 'HK',
  HUF: 'HU',
  IDR: 'ID',
  ILS: 'IL',
  INR: 'IN',
  JPY: 'JP',
  KES: 'KE',
  KRW: 'KR',
  KWD: 'KW',
  LKR: 'LK',
  LSL: 'LS',
  MAD: 'MA',
  MGA: 'MG',
  MWK: 'MW',
  MXN: 'MX',
  MYR: 'MY',
  NAD: 'NA',
  NGN: 'NG',
  NOK: 'NO',
  NPR: 'NP',
  NZD: 'NZ',
  PEN: 'PE',
  PHP: 'PH',
  PKR: 'PK',
  PLN: 'PL',
  PYG: 'PY',
  QAR: 'QA',
  RON: 'RO',
  RWF: 'RW',
  SAR: 'SA',
  SEK: 'SE',
  SGD: 'SG',
  THB: 'TH',
  TRY: 'TR',
  TWD: 'TW',
  USD: 'US',
  UYU: 'UY',
  VND: 'VN',
  XAF: 'CF',
  XOF: 'SN',
  ZAR: 'ZA',
  ZMW: 'ZM',
});

/**
 * An object mapping country codes to the default currency code supported in Airwallex
 *
 * @enum {string}
 * @readonly
 */
export const defaultFundingSourceCurrencyForCountryCode = Object.freeze({
  US: 'USD',
  AU: 'AUD',
  CA: 'CAD',
  DK: 'EUR',
  EE: 'EUR',
  DE: 'EUR',
  HK: 'HKD',
  ID: 'IDR',
  IL: 'ILS',
  MX: 'MXN',
  NL: 'EUR',
  NZ: 'NZD',
  PH: 'PHP',
  SG: 'SGD',
  AE: 'AED',
  GB: 'GBP',
  QA: 'QAR',
});
